/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerlunchname3Inputs */

const en_placeflyerlunchname3 = /** @type {(inputs: Placeflyerlunchname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week's lunch menu`)
};

const de_placeflyerlunchname3 = /** @type {(inputs: Placeflyerlunchname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü der Woche`)
};

/**
* | output |
* | --- |
* | "This week's lunch menu" |
*
* @param {Placeflyerlunchname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerlunchname3 = /** @type {((inputs?: Placeflyerlunchname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerlunchname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerlunchname3(inputs)
	return de_placeflyerlunchname3(inputs)
});
export { placeflyerlunchname3 as "placeFlyerLunchName" }